import React, { useEffect, useRef, useState } from 'react';

const Features = () => {
    const featuresRef = useRef(null);
    const [activeFeature, setActiveFeature] = useState(null);

    useEffect(() => {
        if (!featuresRef.current) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        });

        const featureElements = featuresRef.current.querySelectorAll('.feature-card');
        featureElements.forEach((element) => {
            observer.observe(element);
        });

        return () => {
            featureElements.forEach((element) => {
                observer.unobserve(element);
            });
        };
    }, []);

    const features = [
        {
            id: 1,
            title: "Reserva de Citas 24/7",
            description: "Permite a los clientes programar servicios incluso cuando tu negocio está cerrado, aumentando la disponibilidad y satisfacción.",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            ),
            color: "primary",
            stats: "+40% de reservas fuera del horario laboral"
        },
        {
            id: 2,
            title: "Elimina Reservas Duplicadas",
            description: "Nuestro calendario inteligente previene conflictos de programación automáticamente, evitando problemas de organización.",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            ),
            color: "secondary",
            stats: "100% eliminación de doble reserva"
        },
        {
            id: 3,
            title: "Catálogo Digital",
            description: "Muestra tus servicios con imágenes atractivas y descripciones detalladas, mejorando la experiencia de compra de tus clientes.",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                </svg>
            ),
            color: "primary",
            stats: "+25% más tiempo por cliente"
        },
        {
            id: 4,
            title: "Comunicación Directa",
            description: "Recordatorios automáticos para tus clientes mediante Email y WhatsApp que reduce las cancelaciones de última hora. ",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                </svg>
            ),
            color: "secondary",
            stats: "-60% en cancelaciones"
        },
        {
            id: 5,
            title: "Gestión de Equipo",
            description: "Organiza fácilmente los horarios y especialidades de todos tus profesionales, mejorando la eficiencia del equipo.",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
            ),
            color: "primary",
            stats: "+30% más productividad"
        },
        {
            id: 6,
            title: "Aumenta tus Ingresos",
            description: "Llena espacios vacíos y promociona ofertas especiales automáticamente, maximizando tu capacidad y ganancias.",
            icon: (
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            ),
            color: "secondary",
            stats: "+20% más ingresos mensuales"
        }
    ];

    return (
        <section className="py-32 bg-white relative overflow-hidden" id="caracteristicas">
            {/* Dynamic background gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-gray-100 opacity-80 -z-10"></div>

            {/* Animated background particles */}
            <div className="absolute inset-0 overflow-hidden -z-10">
                <div className="particles-container">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className={`particle bg-${i % 2 === 0 ? 'primary' : 'secondary'} rounded-full absolute opacity-${Math.floor(Math.random() * 3) + 1}0`}
                            style={{
                                width: `${Math.floor(Math.random() * 20) + 5}px`,
                                height: `${Math.floor(Math.random() * 20) + 5}px`,
                                top: `${Math.floor(Math.random() * 100)}%`,
                                left: `${Math.floor(Math.random() * 100)}%`,
                                animationDuration: `${Math.floor(Math.random() * 20) + 10}s`,
                                animationDelay: `${Math.floor(Math.random() * 5)}s`
                            }}
                        />
                    ))}
                </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute right-0 top-0 bottom-0 w-1/3 bg-gradient-to-l from-secondary/10 to-transparent -z-10"></div>
            <div className="absolute left-20 top-64 w-32 h-32 md:w-64 md:h-64 bg-primary/10 rounded-full blur-xl transform -translate-x-1/2 -translate-y-1/2 -z-10"></div>
            <div className="absolute right-10 bottom-20 w-20 h-20 bg-primary/20 rounded-full blur-md -z-10"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-20">
                    <h2 className="text-5xl font-bold mb-6 text-secondary relative inline-block">
                        <span className="relative z-10">Por Qué Nos Eligen</span>
                        <span className="absolute -bottom-2 left-0 right-0 h-3 bg-primary/20 -z-10 transform -rotate-1"></span>
                    </h2>
                    <p className="text-xl text-gray-600 mt-6">
                        Herramientas potentes diseñadas para empresas que ofrecen servicios
                    </p>
                </div>

                {/* Feature selection dots - mobile only */}
                <div className="flex justify-center space-x-2 md:hidden mb-8">
                    {features.map((feature) => (
                        <button
                            key={feature.id}
                            className={`w-3 h-3 rounded-full transition-all duration-300 ${activeFeature === feature.id ? `bg-${feature.color} w-6` : 'bg-gray-300'}`}
                            onClick={() => setActiveFeature(feature.id)}
                            aria-label={`Ver característica: ${feature.title}`}
                        />
                    ))}
                </div>

                {/* Mobile carousel view */}
                <div className="md:hidden relative overflow-hidden">
                    <div
                        className="flex transition-transform duration-500 ease-out"
                        style={{
                            transform: activeFeature ?
                                `translateX(-${(activeFeature - 1) * 100}%)` :
                                'translateX(0)'
                        }}
                    >
                        {features.map((feature) => (
                            <div key={feature.id} className="w-full flex-shrink-0 px-4">
                                <div
                                    className={`feature-card rounded-2xl p-8 shadow-xl h-full
                                        ${feature.color === 'secondary' ? 'bg-secondary text-white' : 'bg-white border-2 border-primary/20 text-gray-800'}`}
                                >
                                    <div className={`flex items-start ${feature.color === 'secondary' ? 'flex-row-reverse text-right' : ''}`}>
                                        <div className={`rounded-2xl p-3 flex-shrink-0 pulse-glow
                                            ${feature.color === 'secondary' ? 'bg-white text-secondary ml-5' : 'bg-primary text-white mr-5'}`}>
                                            {feature.icon}
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                                            <p className={feature.color === 'secondary' ? 'text-white/80' : 'text-gray-600'}>
                                                {feature.description}
                                            </p>
                                            <div className={`mt-4 inline-block font-bold px-4 py-2 rounded-full text-sm
                                                ${feature.color === 'secondary' ? 'bg-white/20 text-white' : 'bg-primary/10 text-primary'}`}>
                                                {feature.stats}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Navigation arrows */}
                    <button
                        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10"
                        onClick={() => setActiveFeature(prev => prev > 1 ? prev - 1 : features.length)}
                        aria-label="Característica anterior"
                    >
                        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button
                        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md z-10"
                        onClick={() => setActiveFeature(prev => prev < features.length ? prev + 1 : 1)}
                        aria-label="Característica siguiente"
                    >
                        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>

                {/* Desktop features grid with hover animations */}
                <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 relative" ref={featuresRef}>
                    {features.map((feature, index) => {
                        // Determine the card's vertical offset for a staggered effect
                        const offsetY = index % 3 === 0 ? 'lg:-translate-y-4' :
                            index % 3 === 1 ? 'lg:translate-y-0' : 'lg:translate-y-6';

                        // Determine whether to use the alternate layout
                        const isAlternate = feature.color === 'secondary';

                        return (
                            <div
                                key={index}
                                className={`feature-card rounded-2xl p-8 shadow-xl transform transition-all duration-500 
                                    hover:-translate-y-4 hover:scale-105 hover:shadow-2xl ${offsetY}
                                    ${isAlternate ? 'bg-secondary text-white' : 'bg-white border-2 border-primary/20 text-gray-800'}
                                    opacity-0 translate-y-10 group`}
                                style={{ transitionDelay: `${index * 100}ms` }}
                            >
                                <div className={`flex items-start ${isAlternate ? 'flex-row-reverse text-right' : ''}`}>
                                    <div className={`rounded-2xl p-3 flex-shrink-0 transition-all duration-500 group-hover:scale-125 
                                        ${isAlternate ? 'bg-white text-secondary ml-5' : 'bg-primary text-white mr-5'}`}>
                                        {feature.icon}
                                    </div>
                                    <div>
                                        <h3 className="text-xl font-bold mb-3 group-hover:translate-x-2 transition-transform">{feature.title}</h3>
                                        <p className={`transition-all duration-300 group-hover:text-opacity-100 ${isAlternate ? 'text-white/80' : 'text-gray-600'}`}>
                                            {feature.description}
                                        </p>

                                        {/* Stats badge - reveals on hover */}
                                        <div className={`mt-4 inline-block font-bold px-4 py-2 rounded-full text-sm
                                            transition-all duration-500 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0
                                            ${isAlternate ? 'bg-white/20 text-white' : 'bg-primary/10 text-primary'}`}>
                                            {feature.stats}
                                        </div>
                                    </div>
                                </div>

                                {/* Animated corner shape */}
                                <div className={`absolute ${isAlternate ? 'bottom-0 left-0 rounded-tr-3xl' : 'top-0 right-0 rounded-bl-3xl'} 
                                    w-12 h-12 transition-all duration-500 group-hover:w-20 group-hover:h-20
                                    ${isAlternate ? 'bg-primary/30' : 'bg-secondary/20'} -z-10`}></div>
                            </div>
                        );
                    })}

                    {/* Connecting lines between features */}
                    <svg className="absolute inset-0 w-full h-full -z-10 hidden lg:block" width="100%" height="100%">
                        <defs>
                            <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#FF6B00" stopOpacity="0.3" />
                                <stop offset="100%" stopColor="#1B3B6F" stopOpacity="0.3" />
                            </linearGradient>
                        </defs>
                        <path d="M150,100 C250,150 350,50 450,100 C550,150 650,50 750,100"
                            stroke="url(#lineGradient)"
                            strokeWidth="2"
                            fill="none"
                            className="feature-connector"
                            strokeDasharray="5,5" />
                    </svg>
                </div>
            </div>

            {/* Animations CSS */}
            <style jsx="true">{`
                .feature-card {
                    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
                }
                
                .feature-card.show {
                    opacity: 1;
                    transform: translateY(0);
                }
                
                .feature-connector {
                    stroke-dashoffset: 1000;
                    animation: drawLine 3s ease-out forwards;
                    animation-delay: 1s;
                }
                
                @keyframes drawLine {
                    to {
                        stroke-dashoffset: 0;
                    }
                }
                
                .particles-container {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                }
                
                .particle {
                    animation: float linear infinite;
                }
                
                @keyframes float {
                    0% {
                        transform: translateY(0) translateX(0) rotate(0deg);
                    }
                    33% {
                        transform: translateY(-50px) translateX(50px) rotate(120deg);
                    }
                    66% {
                        transform: translateY(50px) translateX(-30px) rotate(240deg);
                    }
                    100% {
                        transform: translateY(0) translateX(0) rotate(360deg);
                    }
                }
            `}</style>
        </section>
    );
};

export default Features; 